import React from "react"
import { Box, Button, Image, VStack, StackProps } from "@chakra-ui/react"
import { useRoutes } from "@app/hooks/useRoutes"
import Link from "@app/components/Link"

import { useScavengerHunt } from "@app/hooks/useScavengerHunt"

type Props = StackProps & {
  tags: string[]
  layout?: string
}

const ScavengerHunt: React.FC<Props> = ({ tags, layout, ...rest }) => {
  const { getScavengerHuntFromTags } = useScavengerHunt()
  const scavengerHunt = getScavengerHuntFromTags(tags)
  const { anyUrlResolver } = useRoutes()

  if (!scavengerHunt) return null

  const content = (
    <Button as={Link} to={anyUrlResolver(scavengerHunt.link)?.url} textDecoration="none">
      <Image src={scavengerHunt?.image?.asset?.url || ""} alt="ScavengerHunt" width="100%" />
    </Button>
  )

  if (layout === "pdp") {
    return scavengerHunt.enabled ? (
      <Box position="absolute" top={0} right={0} maxW="180px" w="full" zIndex="9" animation="wiggle 2.5s infinite" {...rest}>
        {content}
      </Box>
    ) : null
  }

  return (
    <VStack alignItems="flex-start" {...rest}>
      {scavengerHunt.enabled && (
        <Box
          position="absolute"
          bottom={4}
          left={4}
          alignItems="center"
          maxW="150px"
          width={{ base: "40%", md: "full" }}
          animation="wiggle 2.5s infinite"
          zIndex="9"
        >
          {content}
        </Box>
      )}
    </VStack>
  )
}

export default React.memo(ScavengerHunt)
